'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSettings = exports.getWidget = exports.getPageRouteProps = exports.getPage = undefined;

var _lodash = require('lodash');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var pageRouteParamsToPropsMap = {
  pageSlug: 'meta.key'
};

var getPage = exports.getPage = function getPage(_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var settings = _ref$cloudData.settings;
  var match = _ref2.match,
      key = _ref2.key,
      _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId;

  return (0, _lodash.get)(settings, builderId + '.data.pages', []).reduce(function (result, item) {
    if (result === undefined && (key !== undefined && (0, _lodash.get)(item, 'meta.key') === key || match && (0, _bdcoreNamedRoutes.paramsMatch)(match.params, pageRouteParamsToPropsMap, item, true))) {
      return item;
    }

    return result;
  }, undefined);
};

var getPageRouteProps = exports.getPageRouteProps = function getPageRouteProps(page) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(page, pageRouteParamsToPropsMap, true);
};

var getWidget = exports.getWidget = function getWidget(_ref3, _ref4) {
  var _ref3$cloudData = _ref3.cloudData;
  _ref3$cloudData = _ref3$cloudData === undefined ? {} : _ref3$cloudData;
  var settings = _ref3$cloudData.settings;
  var key = _ref4.key,
      _ref4$builderId = _ref4.builderId,
      builderId = _ref4$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref4$builderId;

  return (0, _lodash.get)(settings, builderId + '.data.widgets', []).reduce(function (result, item) {
    if (result === undefined && key !== undefined && (0, _lodash.get)(item, 'meta.key') === key) {
      return item;
    }

    return result;
  }, undefined);
};

var getSettings = exports.getSettings = function getSettings(_ref5, _ref6) {
  var _ref5$cloudData = _ref5.cloudData;
  _ref5$cloudData = _ref5$cloudData === undefined ? {} : _ref5$cloudData;
  var settings = _ref5$cloudData.settings;
  var _ref6$builderId = _ref6.builderId,
      builderId = _ref6$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref6$builderId;
  return (0, _lodash.get)(settings, builderId + '.data');
};

exports.default = getPage;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Settings/selectors.js
// module id = 995
// module chunks = 0